export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full">
            <div className="relative rounded-2xl overflow-hidden aspect-[4/3]">
              <img
                src="https://readdy.ai/api/search-image?query=Cozy%20reading%20nook%20with%20a%20tablet%20displaying%20colorful%20manga%20pages%2C%20warm%20ambient%20lighting%2C%20comfortable%20chair%2C%20bookshelf%20in%20background%20with%20manga%20volumes%2C%20soft%20peach%20and%20cream%20color%20palette%2C%20relaxing%20atmosphere%2C%20modern%20minimalist%20interior%2C%20photorealistic%20style&width=640&height=480&seq=about-platform&orientation=landscape"
                alt="51漫画在线阅读体验"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
          <div className="flex-1 w-full">
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-4">关于51漫画</h2>
            <div className="w-12 h-1 bg-primary-500 rounded-full mb-6"></div>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
              51漫画在线观看是国内领先的免费漫画在线阅读平台，致力于为广大漫画爱好者提供优质的在线阅读体验。平台聚合了海量正版漫画资源，涵盖热血、恋爱、奇幻、悬疑、搞笑、科幻等全品类漫画大全。
            </p>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
              我们采用创新的下拉式阅读模式，让读者可以流畅地连续阅读，无需翻页等待。同时支持实时阅读功能，热门连载漫画第一时间更新，让追更不再等待。
            </p>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6">
              51漫画在线始终坚持免费、便捷、高品质的服务理念，无论您使用电脑还是手机，都可以通过网页直接访问51漫画在线看漫画，无需下载任何APP即可享受完整的在线漫画阅读体验。
            </p>
            <div className="flex flex-wrap gap-6">
              <div className="flex items-center gap-2">
                <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center">
                  <i className="ri-shield-check-line text-primary-500 text-lg"></i>
                </div>
                <div>
                  <div className="text-sm font-semibold text-foreground-900">正版授权</div>
                  <div className="text-xs text-foreground-500">安心阅读</div>
                </div>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-10 h-10 rounded-full bg-accent-100 flex items-center justify-center">
                  <i className="ri-flashlight-line text-accent-500 text-lg"></i>
                </div>
                <div>
                  <div className="text-sm font-semibold text-foreground-900">极速加载</div>
                  <div className="text-xs text-foreground-500">流畅体验</div>
                </div>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-10 h-10 rounded-full bg-secondary-100 flex items-center justify-center">
                  <i className="ri-device-line text-secondary-500 text-lg"></i>
                </div>
                <div>
                  <div className="text-sm font-semibold text-foreground-900">多端适配</div>
                  <div className="text-xs text-foreground-500">随时随地</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}